module.exports = __webpack_public_path__ + "static/img/card_08@2x.e7e42c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_08@2x.png
// module id = OB17
// module chunks = 0